export default {
  "该页面暂无权限访问": "This page does not have permission to access",
  "请填写号码": "Please fill in the number",
  "区号": "Area code",
  "全部": "All",
  "上传图片": "Upload pictures",
  "未找到该页面": "The page was not found",
  "选择区号": "Select area code"
}
